import React, {useEffect, useState} from 'react';
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import {LinearProgress} from "@material-ui/core";

const getHoraAtual = () => {
    return new Date().getHours().toString().padStart(2,'0')+':'+
        new Date().getMinutes().toString().padStart(2,'0')+':'+
        new Date().getSeconds().toString().padStart(2,'0');
}

const TituloProgressBar = (props) => {
    const [progress, setProgress] = useState(60);
    const [segundos, setSegundos] = useState(0);

    useEffect(()=>{
            setSegundos(0);
    },[props.titulo]);



    useEffect(()=>{
        //  getPage()
        setSegundos(1);
    },[props.limite]);

    useEffect(()=>{
        //  getPage()
        const interval=setInterval(()=>{
            let x = Math.ceil(segundos * 100 / (props.limite)) ;
            setSegundos(segundos + 1);
            setProgress(x);
        },1000);
        return()=>clearInterval(interval)
    },[segundos]);


        return (<React.Fragment>
                    <LinearProgress variant="determinate" value={progress} />
            </React.Fragment>

        )
    }

export default TituloProgressBar;


